// src/components/FormInput.tsx
import React from 'react';


interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
}

const FormInput: React.FC<FormInputProps> = ({ label, id, ...props }) => {
  return (
    <>
    <div className="custom_input_flled mb-0">
        <label htmlFor={id}>
          {label}
        </label>
        <input
          style={{maxWidth: 'unset'}}
          id={id}
          {...props}
          className={`sm_input filled_white ${props.className || ''}`}
        />
    </div>
    </>
  );
};

export default FormInput;

// Similar components for Select, Textarea etc. can be created